import { isAdvertorial } from '../views/components/advertorial/advertorial';

export function setModifierClass(condition, baseClass, modifier) {
  if (!condition || !baseClass || !modifier) return '';
  return `${baseClass}--${modifier}`;
}

export function setElementClass(elementName, baseClass) {
  if (!elementName || !baseClass) return '';
  return `${elementName}__${baseClass}`;
}

export function createCardWrapperClasses(cardWrapperData) {
  const {
    bigStory,
    rowCardCount,
    columnCard,
    className,
    metadata,
    fullPageAdvertorial
  } = cardWrapperData;

  const events = metadata.events;

  const cardWrapper = 'card-wrapper';
  const advertorial = isAdvertorial(metadata.tags) && !fullPageAdvertorial;
  const advertorialClass = setModifierClass(
    advertorial,
    cardWrapper,
    'advertorial'
  );
  const isEventCard = setModifierClass(events, cardWrapper, 'event-card');
  const isColCard = setModifierClass(columnCard, cardWrapper, 'column-card');
  const hasClassName = setElementClass(className, cardWrapper);

  const allClasses = [
    cardWrapper,
    isEventCard,
    advertorialClass,
    isColCard,
    hasClassName
  ];

  if (metadata.isVideoActive) {
    allClasses.push(`${cardWrapper}--video-active`);
  }

  if (bigStory) {
    allClasses.push(`${cardWrapper}--big`);
  }

  if (rowCardCount && !bigStory) {
    allClasses.push(`${cardWrapper}--${rowCardCount}`);
  }

  return allClasses.filter(element => element).join(' ');
}

export function createCardClasses(cardData) {
  const { className, columnCard, metadata, fullPageAdvertorial } = cardData;
  const events = metadata.events;
  const advertorial = isAdvertorial(metadata.tags) && !fullPageAdvertorial;

  const cardClass = 'card';
  const advertorialClass = setModifierClass(
    advertorial,
    cardClass,
    'advertorial'
  );
  const isEventCard = setModifierClass(events, cardClass, 'event-card');
  const isColCard = setModifierClass(columnCard, cardClass, 'column-card');
  const hasClassName = setElementClass(className, cardClass);

  const allClasses = [
    cardClass,
    hasClassName,
    advertorialClass,
    isEventCard,
    isColCard
  ];

  return allClasses.filter(element => element).join(' ');
}

export function createCardTextWrapperClasses(cardTextWrapperData) {
  const { className, columnCard, metadata } = cardTextWrapperData;
  const textWrapperClass = 'text-wrapper';

  const events = metadata.events;

  const isColCard = setModifierClass(
    columnCard,
    textWrapperClass,
    'column-card'
  );

  const isEventCard = setModifierClass(events, textWrapperClass, 'event-card');
  const hasClassName = setElementClass(className, textWrapperClass);

  const allClasses = [textWrapperClass, isEventCard, hasClassName, isColCard];

  return allClasses.filter(element => element).join(' ');
}

export function createCardTitleClasses(cardTitleData) {
  const { className, metadata } = cardTitleData;
  const cardTitleClass = 'title';
  const events = metadata.events;

  const advertorial = setModifierClass(
    isAdvertorial(metadata.tags),
    cardTitleClass,
    'advertorial'
  );
  const isEventCard = setModifierClass(events, cardTitleClass, 'event-card');
  const hasClassName = setElementClass(className, cardTitleClass);

  const allClasses = [cardTitleClass, advertorial, isEventCard, hasClassName];

  return allClasses.filter(element => element).join(' ');
}

export function createCardDeckClasses(cardDeckData) {
  const { className, metadata, columnCard } = cardDeckData;
  // if this there is no data or a column card, don't show
  if (!metadata.excerpt || className === 'news-column' || columnCard) {
    return null;
  }

  const cardDeckClass = 'deck';

  const hasClassName = setElementClass(className, cardDeckClass);

  const deckClasses = [cardDeckClass, hasClassName];

  return deckClasses.filter(element => element).join(' ');
}

export function createPosterClasses(tags, events, className) {
  const posterClass = 'poster';
  const advertorial = setModifierClass(
    isAdvertorial(tags),
    posterClass,
    'advertorial'
  );
  const isEventCard = setModifierClass(events, posterClass, 'event-card');
  const hasClassName = setElementClass(className, posterClass);

  const allClasses = [posterClass, advertorial, isEventCard, hasClassName];

  return allClasses.filter(element => element).join(' ');
}



// WEBPACK FOOTER //
// ./src/utils/create_class_list_util.js